import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faSpinner} from '@fortawesome/free-solid-svg-icons';
import React from 'react';

export default function Spinner(props) {
  return <FontAwesomeIcon icon={faSpinner} color="#BE131A" spin {...props} />;
}
